module.exports = __webpack_public_path__ + "static/img/drd.35b8029.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/drd.png
// module id = C+lE
// module chunks = 0